export const CHANGELOG_BASE_KEY = 'sesam--changelog';

export const NAVBAR_STORAGE_KEY = 'sesam--navbar';

export const SESAM_RECENT_SEARCHES_STORAGE_KEY = 'sesam--recent-searches';

export const NavBarItemNames = {
  Overview: 'Overview',
  Browse: 'Browse',
  Pipes: 'Pipes',
  Systems: 'Systems',
  Flows: 'Flows',
  Datahub: 'Datahub',
  Subscription: 'Subscription',
} as const;

export const POLL_CONNECT_TO_SUBSCRIPTION_INTERVALS = 20000;
